module.exports = __webpack_public_path__ + "static/media/colliers.a186e873.jpg";